import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import commonMessages, { syncBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { findDomRefAtPos } from '@atlaskit/editor-prosemirror/utils';
import { akEditorSelectedNodeClassName } from '@atlaskit/editor-shared-styles/consts';
import CopyIcon from '@atlaskit/icon/core/copy';
import DeleteIcon from '@atlaskit/icon/core/delete';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { copySyncedBlockReferenceToClipboard, editSyncedBlockSource, removeSyncedBlock } from '../editor-commands';
import { findSyncBlockOrBodiedSyncBlock, isBodiedSyncBlockNode } from '../pm-plugins/utils/utils';
export var getToolbarConfig = function getToolbarConfig(state, intl) {
  var _api$decorations;
  var _options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _providerFactory = arguments.length > 3 ? arguments[3] : undefined;
  var api = arguments.length > 4 ? arguments[4] : undefined;
  var syncBlockStore = arguments.length > 5 ? arguments[5] : undefined;
  var syncBlockObject = findSyncBlockOrBodiedSyncBlock(state);
  if (!syncBlockObject) {
    return;
  }
  var bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
  var isBodiedSyncBlock = isBodiedSyncBlockNode(syncBlockObject.node, bodiedSyncBlock);
  var formatMessage = intl.formatMessage;
  var nodeType = syncBlockObject.node.type;
  var hoverDecoration = api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions.hoverDecoration;
  var hoverDecorationProps = function hoverDecorationProps(nodeType, className) {
    return {
      onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
      onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
      onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
      onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
    };
  };
  var items = [];
  var copyButton = _objectSpread({
    id: 'editor.syncedBlock.copy',
    type: 'button',
    appearance: 'subtle',
    icon: CopyIcon,
    title: formatMessage(messages.copySyncBlockLabel),
    showTitle: true,
    tooltipContent: formatMessage(messages.copySyncBlockTooltip),
    onClick: copySyncedBlockReferenceToClipboard(api)
  }, hoverDecorationProps(nodeType, akEditorSelectedNodeClassName));
  items.push(copyButton);
  var disabled = !syncBlockStore.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
  if (!isBodiedSyncBlock) {
    var editSourceButton = _objectSpread({
      id: 'editor.syncedBlock.editSource',
      type: 'button',
      disabled: disabled,
      appearance: 'subtle',
      icon: LinkExternalIcon,
      title: formatMessage(messages.editSourceLabel),
      showTitle: true,
      tooltipContent: disabled ? formatMessage(messages.editSourceTooltipDisabled) : formatMessage(messages.editSourceTooltip),
      onClick: editSyncedBlockSource(syncBlockStore, api)
    }, hoverDecorationProps(nodeType, akEditorSelectedNodeClassName));
    items.push(editSourceButton);
  }

  // testId is required to show focus on trigger button on ESC key press
  // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
  var testId = 'synced-block-overflow-dropdown-trigger';
  var overflowMenuConfig = [{
    type: 'separator',
    fullHeight: true
  }, {
    type: 'overflow-dropdown',
    testId: testId,
    options: [_objectSpread({
      title: formatMessage(commonMessages.delete),
      onClick: removeSyncedBlock(api),
      icon: /*#__PURE__*/React.createElement(DeleteIcon, {
        label: ""
      })
    }, hoverDecorationProps(nodeType))]
  }];
  items.push.apply(items, overflowMenuConfig);
  var getDomRef = function getDomRef(editorView) {
    var domAtPos = editorView.domAtPos.bind(editorView);
    var element = findDomRefAtPos(syncBlockObject.pos, domAtPos);
    return element;
  };
  return {
    title: 'Synced Block floating controls',
    getDomRef: getDomRef,
    nodeType: nodeType,
    items: items,
    scrollable: true,
    groupLabel: formatMessage(messages.syncBlockGroup)
  };
};